import * as layout from '../../components/markLayout.module.css';
import React, { useMemo } from 'react';
import Table from '@hero/ui-kit/tables/Table';
import type { DripSummary } from '../../types';
import getDripColumns from './getDripColumns';
import usePagerProps from '../../../../hooks/usePagerProps';
type Props = {
    drips: DripSummary[];
    isLoading: boolean;
    pagerProps: ReturnType<typeof usePagerProps>;
};
const DripsList: React.FC<Props> = ({ drips, isLoading, pagerProps }) => {
    const columns = useMemo(() => getDripColumns(), []);
    return (
        <div
            style={{
                overflowX: 'auto'
            }}
            className={layout.tableScroll}
        >
            <Table<DripSummary>
                columns={columns}
                data={drips}
                rowKey="drip_id"
                emptyValues="-"
                isLoading={isLoading}
                pagerProps={pagerProps}
            />
        </div>
    );
};
export default DripsList;
